<template>


  <el-dialog
      v-model="dialogVisible"
      align-center
      width="600px"
      class="login-content">
    <template #header="{ close, titleId, titleClass }">
      <div class="my-header">
        <h2 style="text-align: center">用户登录</h2>
      </div>
    </template>
    <el-form
        label-width="100px" class="demo-ruleForm"
        :rules="rules"
        :model="rulesForm"
        status-icon
        ref="ruleForm"
    >
      <el-form-item label="手机号" prop="mobile">
        <el-input type="text" v-model="rulesForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="rulesForm.password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>

        <el-button>重置</el-button>
      </el-form-item>
    </el-form>


  </el-dialog>
</template>


<script>
import {ref} from 'vue'
import {login} from '@/api/Patent.js'
import {useStore} from "vuex";
import {setCookie} from "@/utils/cookie";

export default {
  setup(props) {
    const dialogVisible = ref(false)
    // 获取仓库对象
    const store = useStore();

    const setStore = (data) => {
      store.dispatch('user/updateToeknAsync', data.body.token);
      store.dispatch('user/updateNameAsync', data.body.name);
    }

    return {dialogVisible, setStore};
  },
  props: {
    loginFormClick: {
      type: Number,
      default: 0
    },
  },
  watch: {
    loginFormClick() {
      this.dialogVisible = true
    }
  },
  data() {
    return {
      //存储数据的对象
      rulesForm: {
        mobile: '',
        password: ''
      },
      rules: {
        mobile: [
          {required: true, message: '请输入名字', trigger: "blur"},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: "blur"},
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      const store = useStore();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //如果校检通过，在这里向后端发送用户名和密码
          login({
            password: this.rulesForm.password,
            mobile: this.rulesForm.mobile
          }).then((data) => {
            console.log(data)
            if (data.success) {
              this.$message.success(data.msg)
              this.dialogVisible = false
              this.setStore(data)
              // cookie 有效期与后端 JWT 有效期(2小时)对齐
              setCookie('token', data.body.token, 2 / 24)
            }else{
              this.$message.error(data.msg)
            }

          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
}


</script>
<style lang="less" scoped>
.login-section {
  padding: 0px 20px
}

</style>